import {
    NotificationTableView,
} from 'app/Apps/OrderManagement/Orders/Components/OrderNotifications/utils/OrderNotifications.types'

import useStyles from './LastSentOn.style'

type Props = {
    value?: string,
    rowProps: NotificationTableView,
}

const defaultProps: Partial<Props> = {
    value: undefined,
}

const LastSentOn = ({
    value,
    rowProps,
}: Props) => {
    const {
        classes,
    } = useStyles()

    const {
        optional,
        triggerDescription,
    } = rowProps

    if (value) {
        return value
    }

    return (
        <>
            <span>
                {
                    optional ? 'Optional' : 'Not yet sent'
                }
            </span>
            <img
                src="assets/images/info.svg"
                alt="info"
                title={triggerDescription}
                className={classes.icon}
            />
        </>
    )
}

LastSentOn.defaultProps = defaultProps

export default LastSentOn
